import { EventEmitter } from "@shop/frontend/web/js/components/EventEmitter";
import api from "@shop/frontend/web/js/api";
import { translator } from "@shop/frontend/web/js/services/TranslatorService";
import { Modal } from "@shop/frontend/web/js/components/Modal";
import { EventOrderModel } from '@shop/frontend/web/js/models/EventOrderModel'

translator.getLanguages();
const orderModel = new EventOrderModel();

class AdditionalServicesController {
  constructor() {
    
    this.emitter = new EventEmitter();
    this.modal = new Modal();
    this.popup = new Modal({ className: 'additional-modal', id:'additional-services-modal' });
    this.additionalServicesPromptModal = new Modal({ className: 'additional-prompt-modal', id: 'additional-services-prompt-modal' });
  }

  init() {
    this.setUpListeners();
    this.fragmentAdditionalServicesItem = document.importNode($("#js-template-additional-services-item")[0].content, true);
    this.fragmentAdditionalServicesItemAdded = document.importNode($("#js-template-additional-services-item-added")[0].content, true);
    this.fragmentAdditionalServicesList = document.importNode($("#js-template-additional-services")[0].content, true);
    this.fragmentAdditionalServicesPromptModal = document.importNode($("#js-template-additional-services-prompt-modal")[0].content, true);
  }

  setUpListeners() {
    $(document).on('click', '#js-places-buy', (e) => {
      if(this.checkAddedService()) {
        e.preventDefault();
        const fragmentAdditionalServicesPromptModal = this.fragmentAdditionalServicesPromptModal.cloneNode(true);
        this.additionalServicesPromptModal.show(fragmentAdditionalServicesPromptModal, { focus: false });
      }
    });

    if(this.checkAddedService()) {
      this.showServiceNotification()
    }else {
      this.hideServiceNotification()
    }

    $(document).on("click", ".additional-services__ticket", e => {
      this.additionalServicesPromptModal.hide();
      $('.js-additional-services').trigger('click');
    });

    $(document).on('click', '.js-additional-services', (e) => {

      const $services = $(e.currentTarget); 
      let additionalServicesData = $services.attr('additional-services-data');
      let additionalTicketsData = $services.attr('additional-tickets-data');

      const orderID = $services.attr('data-order-id');

      let additionalServicesParsed = JSON.parse(additionalServicesData)
      let result = additionalServicesParsed

      if(additionalTicketsData) {
        additionalTicketsData = JSON.parse(additionalTicketsData || [])
        result = additionalServicesParsed.map(item1 => {
          const matchCount = additionalTicketsData.filter(item2 =>
            item1.name === item2.name &&
            item1.price === item2.price &&
            item1.view_id === item2.view_id
          ).length;
        
          return {
            ...item1,
            service_count: matchCount
          };
        });
      }


      if (additionalServicesData) {
        try {
          const parsedData = result
          const fragmentRefund = this.buildAdditionalServicesModalContent(parsedData, orderID);
          this.renderPopUpTemplate(fragmentRefund);
          this.updateCheckbox();
          this.updateServiceCount();
        } catch (error) {
          console.error('Ошибка при парсинге additionalServicesData:', error);
        }
      } else {
        console.warn('Атрибут additionalServicesData отсутствует.');
      }

      // if(this.checkAddedService()) {
      //   this.showServiceNotification()
      // }else {
      //   this.hideServiceNotification()
      // }
    });

    $(document).on('click', '.js-additional-services-confirm', (e) => {
      const checkedCheckboxes = $('.additional-service[service_count]').filter(function() {
        return parseInt($(this).attr('service_count')) > 0;
      });

      function getTotalAdditionalTicketsPrice(dataArray) {
        return dataArray.reduce((total, item) => {
            if (!item.additionalTickets || !Array.isArray(item.additionalTickets) || item.additionalTickets.length === 0) {
              return total;
            }
            return total + item.additionalTickets.reduce((sum, ticket) => sum + ticket.price, 0);
        }, 0);
      }

      let additionalServicesToSend = [];

      checkedCheckboxes.each((index, element) => {
        let countAdditionlService = $(element).attr('service_count');
        let additionalItemOrderId = $(element).attr('order_id');
        let additionalItemParent = $(element).attr('parent');
        let additionalItemServiceId = $(element).attr('service_id');
        let additionalItemViewId = $(element).attr('view_id');

        let additionalService = {
            orderId: additionalItemOrderId,
            parent: additionalItemParent,
            serviceId: additionalItemServiceId,
            priceTypeId: additionalItemViewId,
          };

          for (let i = 0; i < countAdditionlService; i++) {
            additionalServicesToSend.push(additionalService);
          }
      });

      let parentTicketUid;

      if(additionalServicesToSend.length === 0) {
        let firstAdditionalServicesItem = $(e.currentTarget).closest('.additional-services__container').find('.additional-service').first();
      
        let orderId = firstAdditionalServicesItem.attr('order_id');
        let parentId = firstAdditionalServicesItem.attr('parent');

        additionalServicesToSend.push({
          orderId,
          parent: parentId,
          serviceId: null,
          priceTypeId: null,
        })

        parentTicketUid = parentId;
      } else {
        parentTicketUid = additionalServicesToSend[0].parent;
      }
      
      const additionalServicesPayload = {
        items: additionalServicesToSend,
      };

      const jsonPayload = JSON.stringify(additionalServicesPayload);
      
      api.additionalServices
        .addAdditionalServices(jsonPayload)
        .then((res) => {
          if(res.error) {
            $('.additional-services__container').html('<p>Не удалось добавить услугу. Возможно превышен лимит добавленных услуг на одно мероприятие</p>');
            let parentTicket = $(`.tickets__item[data-uid="${parentTicketUid}"]`);
            parentTicket.find('.js-additional-services')
              .html(``);
          } else {
            let parentTicket = $(`.tickets__item[data-uid="${parentTicketUid}"]`);

            const additionalTicketsData = Array.isArray(res.carts)
            ? res.carts
                .filter(cart => cart.uid === parentTicketUid)
                .flatMap(cart => cart.additionalTickets || [])
            : [];

            const serviceBtn = parentTicket.find('.js-additional-services');
            const additionalTicketsCount = additionalTicketsData.length;
            const hasAdditionalTickets = additionalTicketsCount > 0;

            const serviceBtnContent = hasAdditionalTickets
              ? {
                  svgId: '#service-added',
                  svgSize: 17,
                  text: additionalTicketsCount > 1 ? translator.t("main", "Services added") : translator.t("main", "Service added"),
                  className: 'additional-services__added-service',
                }
              : {
                  svgId: '#service-add',
                  svgSize: 16,
                  text: translator.t("main", "Add a service"),
                  className: 'additional-services__add-service',
                };
            
              serviceBtn
              .html(`
                <svg width="${serviceBtnContent.svgSize}" height="${serviceBtnContent.svgSize}" aria-hidden="true" focusable="false">
                  <use xlink:href="${serviceBtnContent.svgId}"></use>
                </svg>
                <span>${serviceBtnContent.text}</span>
              `)
              .removeClass('additional-services__added-service additional-services__add-service')
              .addClass(serviceBtnContent.className)
              .attr('additional-tickets-data', JSON.stringify(additionalTicketsData));
            
            let currentTicket = res.carts.find((ticket, i) => {
              return ticket && ticket.uid === parentTicketUid;
            })

            if(currentTicket) {
              function getTotalAdditionalTicketsPrice(ticket) {
                if (ticket.additionalTickets && Array.isArray(ticket.additionalTickets)) {
                  return ticket.additionalTickets.reduce((total, currentTicket) => total + currentTicket.price, 0);
                }

                return 0;
              }

              parentTicket.find('.js-ticket-price').text(getTotalAdditionalTicketsPrice(currentTicket) + currentTicket.price)
            }

            let order = {
              carts: res.carts,
              id: res.carts[0].orderId,
            }

            let eventSum = orderModel.validateOrderData(order);
            $("#js-event-sum").text(eventSum.amount)
            this.popup.hide();
            this.checkAddedService();
          }
        })
        .catch((err) => {
          console.log(e);
        })
        .finally(() => {
          if(this.checkAddedService()) {
            this.showServiceNotification()
          } else {
            this.hideServiceNotification()
          }
        })
    });

    $(document).on("click touchstart", ".additional-service__scheme-link", function (e) {
      let modal = $(e.target).closest('.i-modal__body');
    
      let modalContainer = modal.find('.additional-services__container');
      let ticket = $(e.target).closest('.additional-service')
      let imgContainer = ticket.find('.additional-service__img-container');
      let linkBack = modal.find('.additional-service__link-back')

      modalContainer.css('display', 'none');

      $('.additional-service__img-container').css('display', 'none')
      
      imgContainer.css('display', 'block');
      modal.append(imgContainer);
      
      $(linkBack).on('click', () => {
        imgContainer.css('display', 'none');
        modalContainer.css('display', 'block');
        ticket.append(imgContainer)
      })
    
    });

    $(document).on("click", '#js-close-refund-popup',(e) => {
      this.popup.hide();
    })
  }

  buildAdditionalServicesModalContent(parsedData, orderID) {

    const createFragmentAdditionalServicesInstance = (data) => {
      
      const { name, parent, price, service_id, view_id, view_name, service_count, is_auto_added } = data;
    
      let fragmentAdditionalServicesInstance = (price === 0 
        ? this.fragmentAdditionalServicesItemAdded 
        : this.fragmentAdditionalServicesItem
      ).cloneNode(true);
    
      const $fragment = $(fragmentAdditionalServicesInstance);
      const $service = $fragment.find(".additional-service");
    
      $service.attr('name', name);
      $service.attr('order_id', orderID);
      $service.attr('parent', parent);
      $service.attr('service_id', service_id);
      $service.attr('view_id', view_id);
      $service.attr('service_count', service_count);
    
      $fragment.find(".additional-service__name").append(name);
      $fragment.find(".additional-service__price").append(price + ' ₽');
      $fragment.find(".additional-service__desc").append(view_name);
      $fragment.find(".additional-service__service-count").text(service_count);

        // let parkingScheme = [
        //   {'image': '/images/parking-scheme/parking-1.jpg', 'service-id': '224'},
        //   {'image': '/images/parking-scheme/parking-2.jpg', 'service-id': '225'},
        //   {'image': '/images/parking-scheme/parking-3.jpg', 'service-id': '226'},
        //   {'image': '/images/parking-scheme/parking-1.jpg', 'service-id': '35'},
        //   {'image': '/images/parking-scheme/parking-2.jpg', 'service-id': '36'},
        //   {'image': '/images/parking-scheme/parking-3.jpg', 'service-id': '37'}
        // ];
  
        // let parkingImage = parkingScheme.find(item => item['service-id'] === service_id.toString());
  
        // if (parkingImage) {
        //   $(fragmentAdditionalServicesInstance).find(".additional-service__scheme-link").append(translator.t("main", "View diagram"));
      
        //   let img = $(fragmentAdditionalServicesInstance).find(".additional-service__img");
        //   img.attr('src', parkingImage.image);
  
        //   if(service_id === 226 || service_id === 37) {
        //     $(fragmentAdditionalServicesInstance).find(".additional-service__scheme-link").on('click', function() {
        //       $(this).next(".additional-service__img-container").addClass('big-modal');
        //     });
  
        //     $(fragmentAdditionalServicesInstance).find(".additional-service__link-back").on('click', function() {
        //       $(this).closest(".additional-service__img-container").removeClass('big-modal');
        //     });
        //   }
        
        //   $(fragmentAdditionalServicesInstance).find(".additional-service__link-back")
        //   .append('<svg width="20" height="20" aria-hidden="true" focusable="false"><use xlink:href="#additional-service-back"></use></svg>')
        //   .append(translator.t("main", "Back"));
        // }

      return fragmentAdditionalServicesInstance;
    };
  
    const fragmentAdditionalServicesList = this.fragmentAdditionalServicesList.cloneNode(true);
    
    parsedData.reverse().forEach((element) => {
      const fragmentRefund = createFragmentAdditionalServicesInstance(element);
      $(fragmentAdditionalServicesList).find('.additional-services__list').prepend(fragmentRefund);
    });
  
    return fragmentAdditionalServicesList;
  }

  checkAddedService() {
    const ticketsItems = $('.tickets__items');
    const hasAddService = ticketsItems.find('.additional-services__add-service').length > 0;
    const hasAddedService = ticketsItems.find('.additional-services__added-service').length > 0;

    return hasAddService && !hasAddedService;
  }

  showServiceNotification() {
    $('.tickets__notification').addClass('active');
    $('.tickets__notification_mobile').addClass('active');
  }

  hideServiceNotification() {
    $('.tickets__notification').removeClass('active');
    $('.tickets__notification_mobile').removeClass('active');
  }

  updateServiceCount() {
    $(".additional-service__plus-service").on('click', function() {
      let additionalServiceTicket = $(this).closest('.additional-service');
      let countService = additionalServiceTicket.find('.additional-service__service-count');
      let currentServiceCount = parseInt(countService.text()) || 0;
      let newServiceCount = currentServiceCount + 1;
      countService.text(newServiceCount);
      additionalServiceTicket.attr('service_count', newServiceCount)
    })

    $(".additional-service__minus-service").on('click', function() {
      let additionalServiceTicket = $(this).closest('.additional-service');
      let countService = additionalServiceTicket.find('.additional-service__service-count');
      let currentServiceCount = parseInt(countService.text()) || 0;
      if(currentServiceCount > 0) {
        let newServiceCount = currentServiceCount - 1;
        countService.text(newServiceCount);
        additionalServiceTicket.attr('service_count', newServiceCount)
      }
    })
  }

  getCountCheckedCheckboxes() {
    const checkboxes = $(".js-additional-service-checkbox");
    let count = 0;

    $(checkboxes).each((index, checkbox) => {
      const $checkbox = $(checkbox);
  
      if ($checkbox.is(":checked")) {
          $checkbox.closest('.additional-service').addClass('active');
          count++;
      } else {
          $checkbox.closest('.additional-service').removeClass('active');
      }
    });
    
    return count;
  }

  updateCheckbox() {
    const checkboxes = $(".js-additional-service-checkbox");
    let confirmRefundButton = $("#js-additional-services-confirm:visible");

    checkboxes.on("change", (e) => {
        if (this.getCountCheckedCheckboxes() > 0) {
            const confirmRefundButton = $(e.target).closest('.additional-services__container')
            .find('.js-additional-services-confirm')
        } else {
          const confirmRefundButton = $(e.target).closest('.additional-services__container')
          .find('.js-additional-services-confirm')
        }
    });
  }

  renderPopUpTemplate(fragment) {
    this.popup.show(fragment, { focus: false });
  }
}

$(document).ready(() => {
  const additionalServicesController = new AdditionalServicesController();
  additionalServicesController.init();
});